import { CalendarProviderType } from '../store/schema/CalendarProviderType';
import { assertNever } from 'owa-assert';
import { OAuthProviderType } from 'owa-link-account';

export function getOAuthProviderType(providerType: CalendarProviderType): OAuthProviderType {
    switch (providerType) {
        case CalendarProviderType.TeamSnap:
            return OAuthProviderType.TeamSnap;
        case CalendarProviderType.Unknown:
            throw new Error(`No matching oath provider type for : ${CalendarProviderType.Unknown}`);
        default:
            return assertNever(providerType);
    }
}
